// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string(),
  name: __t.string(),
  ruleset: __t.string(),
  admissionOpen: __t.bool().name("admission_open"),
  live: __t.bool(),
  formationCount: __t.u32().name("formation_count"),
  capacity: __t.u32(),
  starterUnitCount: __t.u32().name("starter_unit_count"),
  starterSummary: __t.string().name("starter_summary"),
  endpointUrl: __t.string().name("endpoint_url"),
  terrainRevision: __t.string().name("terrain_revision"),
  tick: __t.u64(),
  leaseUntil: __t.timestamp().name("lease_until"),
});
